module.exports = ".list-style {\n  list-style: none !important; }\n\n.pd-0 {\n  padding: 0 !important; }\n\n.card {\n  border: none;\n  overflow: hidden;\n  position: relative;\n  height: 50% !important; }\n\n.card-body {\n  max-height: 100%;\n  max-width: 100%;\n  position: absolute;\n  overflow-y: auto; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/forms/shared/sent-by/sent-by.component.scss
// module id = ./src/app/forms/shared/sent-by/sent-by.component.scss
// module chunks = main